import { literal, number, object, string, union, z } from "zod";

export const InfoModalResSchema = object({
  message: string(),
  statusReg: union([literal("fail"), literal("success")]),
});

export const SignUpErrorResDto = object({
  ex: string(),
  statusReg: literal("fail"),
  eventCode: number().optional(),
});

export const SignUpLangingResDto = object({
  keyReg: string(),
  statusReg: literal(""),
});

export const SignUpLoginRedirectResDto = object({
  login: literal("1"),
  statusReg: literal(""),
});

export const InfoModalSignUpResSchema = union([
  SignUpErrorResDto,
  SignUpLangingResDto,
  SignUpLoginRedirectResDto,
]);

// InfoModalSignUpResSchema
export type SignUpErrorResDto = z.infer<typeof SignUpErrorResDto>;
export type SignUpLangingResDto = z.infer<typeof SignUpLangingResDto>;
export type SignUpLoginRedirectResDto = z.infer<
  typeof SignUpLoginRedirectResDto
>;

export type InfoModalResDto = z.infer<typeof InfoModalResSchema>;
export type InfoModalSignUpResDto = z.infer<typeof InfoModalSignUpResSchema>;
